import { render } from "./ZNdit.vue?vue&type=template&id=4c5b7bc5&scoped=true"
import script from "./ZNdit.vue?vue&type=script&lang=js"
export * from "./ZNdit.vue?vue&type=script&lang=js"

import "./ZNdit.vue?vue&type=style&index=0&id=4c5b7bc5&lang=scss&scoped=true"
import "./ZNdit.vue?vue&type=style&index=1&id=4c5b7bc5&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5b7bc5"]])

export default __exports__